import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => {
    return (
        <div className="LoadingSpinner">
            <div className="doubleBounce1"></div>
            <div className="doubleBounce2"></div>
        </div>
    );
};

export default LoadingSpinner;
